import { DateTime } from "luxon";

export const TIMESTAMP_TYPES: Record<string, (date: luxon.DateTime) => string> =
	{
		F: (d) =>
			d.toLocaleString({
				month: "long",
				weekday: "long",
				day: "2-digit",
				year: "numeric",
				hour: "numeric",
				minute: "numeric",
			}),
		f: (d) =>
			d.toLocaleString({
				month: "long",
				year: "numeric",
				day: "2-digit",
				hour: "numeric",
				minute: "numeric",
			}),
		D: (d) =>
			d.toLocaleString({
				month: "long",
				day: "2-digit",
				year: "numeric",
			}),
		d: (d) =>
			d.toLocaleString({
				month: "2-digit",
				day: "2-digit",
				year: "numeric",
			}),
		t: (d) =>
			d.toLocaleString({
				hour: "numeric",
				minute: "numeric",
			}),
		T: (d) => d.toLocaleString(DateTime.TIME_WITH_SECONDS),
		R: (d) => d.toRelative({}),
		s: (d) =>
			d.toLocaleString({
				month: "2-digit",
				day: "2-digit",
				year: "numeric",
				hour: "numeric",
				minute: "numeric",
			}),
		S: (d) =>
			d.toLocaleString({
				month: "2-digit",
				day: "2-digit",
				year: "numeric",
				hour: "numeric",
				minute: "numeric",
				second: "numeric",
			}),
	};
